import { ChangeDetectionStrategy, Component } from '@angular/core';

import { Mapper } from 'tiime-expert-utils';

import { CompanyContactsBase, CompanyContactsBaseImports } from '@bases/company-contacts/company-contacts.base';
import { User } from '@models/user';
import { PhonePipe } from '@shared-pipes/phone/phone.pipe';

@Component({
  selector: 'app-company-users-contacts',
  standalone: true,
  imports: [...CompanyContactsBaseImports],
  templateUrl: './../../../core/bases/company-contacts/company-contacts.base.html',
  styleUrls: ['./../../../core/bases/company-contacts/company-contacts.base.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CompanyUsersContactsComponent extends CompanyContactsBase<User> {
  readonly mapToContactPrefix: Mapper<User, string> = (user: User) => '';

  readonly mapToContactFullName: Mapper<User, string> = (user: User) => user.fullName;

  readonly mapToContactSuffix: Mapper<User, string> = (user: User) =>
    user.phone ? ` (${new PhonePipe().transform(user.phone)})` : '';

  readonly mapToContactTooltip: Mapper<User, string> = () => '';
}
